module.exports = __webpack_public_path__ + "img/right.a2701551.png";